import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'copy-filters-modal.common.flags.filter-loading-failed.title',
		defaultMessage: 'Filter loading failed.',
		description:
			'Flag title. Flag is shown when user requested to open Copy Filter modal, but the request to fetch this filter failed.',
	},
});

const filterLoadingFailedFlag = (): FlagConfiguration => ({
	type: 'error',
	title: messages.title,
	isAutoDismiss: true,
	messageId: 'copy-filters-modal.common.ui.flags.filter-loading-failed.flag.error',
	messageType: 'transactional',
});

export default filterLoadingFailedFlag;
